import React from 'react'
import { Icons } from 'msp-components'
import { ToggleFilterType } from '../ProductList.types'
import { FilterLabel } from './FilterLabel'
import { useIntl } from 'react-intl'

type SelectedFilterElementProps = {
  className?: string
  attributeId: string
  value: string
  label: string
  toggleFilter: ToggleFilterType
  parentCategory?: string
}

const SelectedFilterElement = ({
  className,
  attributeId,
  value,
  label,
  toggleFilter,
  parentCategory
}: SelectedFilterElementProps) => {
  const { formatMessage } = useIntl()
  return (
    <div
      className={`border-machine2-75 mb-2 mr-5 flex h-8 rounded-sm border fill-black px-3 align-middle ${className}`}
    >
      <div className='font-Roboto text-14 tracking-0 flex w-full flex-nowrap items-center whitespace-nowrap'>
        <FilterLabel label={label} attributeID={attributeId} isSelected />
      </div>
      <button
        aria-label={`${formatMessage({
          defaultMessage: 'Remove filter for',
          id: 'msp.selected_filter.filter.remove'
        })} ${label}`}
        className='cc-outline-close-btn-black ml-2 flex min-w-min cursor-pointer items-center justify-end'
        onClick={() =>
          toggleFilter(
            value,
            attributeId,
            true,
            true,
            !!parentCategory,
            parentCategory
          )
        }
      >
        <Icons iconName='Close' />
      </button>
    </div>
  )
}

export default SelectedFilterElement
